import type { UseQueryResult } from '@tanstack/react-query';
import type { RoleMember } from '../services/roles';

type RoleMembersResult = Pick<UseQueryResult<RoleMember[]>, 'data' | 'isLoading'>;

// Staff can belong to several teams, so the first role (by id) to list an email wins.
export function combineMembers(results: RoleMembersResult[]) {
    const byEmail = new Map<string, RoleMember>();
    for (const member of results.flatMap((result) => result.data ?? [])) {
        if (!byEmail.has(member.email)) {
            byEmail.set(member.email, { ...member, fullname: member.fullname || member.email });
        }
    }
    return {
        members: [...byEmail.values()],
        isLoading: results.some((result) => result.isLoading)
    };
}
